/** @format */

import React, { FC, useState, useMemo, useEffect } from 'react'
import styled from 'styled-components'
import { _$, Drawer, ButtonGroup, Button } from '@king-design/react'
import { CloseFooter, TablePage } from 'src/components'
import { edgeTabelData } from './constants'

interface EdgeDrawerProps {
  className?: string
  visible: boolean
  onClose: () => void
  dataSource: string
  edgeData: any
  nodes: any[]
}

const EdgeDrawer: FC<EdgeDrawerProps> = ({ className, visible, onClose, edgeData, nodes }) => {
  const [active, setActive] = useState<string>('')
  const [data, setData] = useState<any>()

  // 抽屉打开默认值
  useEffect(() => {
    if (visible && edgeData) {
      setActive(edgeData?.links[0].LinkId)
      setData(edgeData?.links[0])
    }
  }, [visible, edgeData])

  // 切换LINK按钮
  const onChangeLink = value => {
    if (edgeData?.links?.length) {
      setActive(value)
      const findLink = edgeData?.links?.find(({ LinkId }) => LinkId === value)
      findLink && setData(findLink)
    }
  }

  // 获取端口信息
  // const { value: port_value, loading: port_loading } = useAsync(async () => {
  //   if (visible && data) {
  //     const { ANeDN, ZNeDN, APortName, ZPortName } = data
  //     const source_result = await request(Api.getNCEPortIndicator, {
  //       data: { DataSource: dataSource, NeDN: ANeDN, PortName: APortName }
  //     })
  //     const target_result = await request(Api.getNCEPortIndicator, {
  //       data: { DataSource: dataSource, NeDN: ZNeDN, PortName: ZPortName }
  //     })
  // eslint-disable-next-line max-len
  //     const source_data = source_result?.data?.ListPortIndicatorsResult?.Data?.PortIndicator || []
  // eslint-disable-next-line max-len
  //     const target_data = target_result?.data?.ListPortIndicatorsResult?.Data?.PortIndicator || []
  //     return {
  //       source: source_data,
  //       target: target_data
  //     }
  //   }
  // }, [visible, data])

  const portTableData = useMemo(() => {
    if (data) {
      const { ANeDN, ZNeDN, ANeName, ZNeName, ANeIP, ZNeIP, APortName, ZPortName } = data
      // const { source, target } = port_value
      const tableData = edgeTabelData.map((column, index) => {
        switch (index) {
          case 0:
            column.source = ANeName || '-'
            column.desination = ZNeName || ''
            break
          case 1:
            column.source = ANeIP || '-'
            column.desination = ZNeIP || ''
            break
          case 2:
            const source_find = nodes.find(({ id }) => id === ANeDN)
            const desination_find = nodes.find(({ id }) => id === ZNeDN)
            column.source = source_find?.FabricNeRoles || '-'
            column.desination = desination_find?.FabricNeRoles || '-'
            break
          case 3:
            column.source = APortName || '-'
            column.desination = ZPortName || ''
            break
        }
        return column
      })
      return tableData
    }
    return []
  }, [data])

  const scheme = {
    name: {
      title: _$('名称'),
      width: 150
    },
    source: {
      title: _$('源信息')
    },
    desination: {
      title: _$('目标信息')
    }
  }

  return (
    <div id="edge_drawer">
      <Drawer
        value={visible}
        width={600}
        container={() => document.getElementById('edge_drawer')}
        onChangeValue={show => !show && onClose()}
        title={_$('链路详情')}
        slotFooter={<CloseFooter onClose={onClose} />}
      >
        <div className={className}>
          {edgeData?.links?.length > 1 ? (
            <ButtonGroup
              checkType="radio"
              value={active}
              onChangeValue={value => {
                onChangeLink(value)
              }}
            >
              {edgeData?.links?.map((link, index) => (
                <Button key={link.LinkId} value={link.LinkId}>
                  {`LINK${index + 1}`}
                </Button>
              ))}
            </ButtonGroup>
          ) : null}
          <p className="title">{_$('链路信息')}</p>
          <TablePage
            tableProps={{
              data: portTableData || [],
              checkType: 'none',
              scheme: scheme
            }}
            showPage={false}
          ></TablePage>
        </div>
      </Drawer>
    </div>
  )
}

export default styled(EdgeDrawer)`
  .title {
    margin-top: 16px;
    padding: 12px 20px 12px 20px;
    height: 52px;
    line-height: 28px;
    background: #f8f8fa;
    color: #3c4449;
    font-size: 14px;
  }
  .k-btns {
    .k-btn {
      &.level_1 {
        color: red;
      }
      &.k-active {
        color: #0091ea;
      }
    }
  }
  .k-table {
  }
  .cable_info {
    p {
      padding: 8px 0;
      margin: 0;
      color: #848f9a;
      span {
        margin-left: 8px;
        color: #3c4449;
      }
    }
  }
`
